export default "__VITE_ASSET__CmTYkZim__"